import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonErrorEventsCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import FormErrorEvent from 'system/components/error-events/form';
import { EventError } from 'shell/models/event-error';
import { transformEventError, transformTypeEventResponse } from '../utils/transform-event-error';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { HttpRequestFunction, ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const ErrorEventDetailPage = (): React.ReactElement => {
  const params = useParams();

  const navigate = useNavigate();

  const resubmitEventError = useHttpClient<void>(
    `${__OPERATION__EVENT__ADMIN__}/eventoInErrore/reinoltraEvento`,
    {
      options: {
        errorCatching: true,
        method: 'PUT',
        loading: true,
        data: {},
      },
    }
  );

  const onSubmit = useCallback(() => {
    return (
      resubmitEventError({
        url: `/${params.id}`,
      }) as ResponsePromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/ricerca-eventi-in-errore');
    });
  }, [resubmitEventError, navigate]);

  const [eventError, getEventError] = useHttpFetch<
    HttpResponse<EventError>,
    transformTypeEventResponse
  >(`${__OPERATION__EVENT__ADMIN__}/eventoInErrore/${params.id}`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformEventError,
  });

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonErrorEventsCrumbs, { name: 'Dettaglio evento In errore' }]} />
      <FormErrorEvent
        title="Dettaglio Evento In Errore"
        initialValues={eventError?.data as transformTypeEventResponse}
        onResubmit={onSubmit}
        disabled
        getEventError={
          getEventError as HttpRequestFunction<HttpResponse<EventError>, transformTypeEventResponse>
        }
        onCancel={() => {
          navigate('/sistema/eventmanager/ricerca-eventi-in-errore');
        }}
      />
    </Fragment>
  );
};

ErrorEventDetailPage.displayName = 'Error Event Page Detail component';

export default ErrorEventDetailPage;
